module.exports = __webpack_public_path__ + "static/architecture-ae616b62c16ad545305bd42f32ea9bff.svg";